import { PART_CATALOGS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/part_catalogs_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'PART_CATALOGS_FOR_PART',
	'partsCatalogDropdown',
	'VENDOR_ASSOCIATED_PARTS_TARGET_COLLECTION',
	'add_in_pr_index',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
